import {CookieStorage} from 'cookie-storage';
import {env} from "../utils/functions";

class Storage {
    driver = 'local'
    storage;
    prefix;

    constructor (driver, prefix = 'default') {
        this.driver = driver;
        this.storage = this.getStorage();
        this.prefix = prefix;
    }

    getStorage () {
        switch (this.driver) {
            case 'session':
                return sessionStorage;
            case 'cookie':
                return new CookieStorage();
            default:
                return localStorage;
        }
    }

    set (key, data, attributes) {
        if (this.driver === 'cookie') {
            this.storage.setItem(this.getKey(key), JSON.stringify(data), attributes);
        } else {
            let item = {
                'data': data,
                'attributes': attributes
            };
            this.storage.setItem(this.getKey(key), JSON.stringify(item))
        }
    }

    get (key) {
        let item = this.storage.getItem(this.getKey(key));
        item = JSON.parse(item);
        if (this.driver === 'cookie') {
            return item;
        } else {
            if (item && typeof item['attributes'] === 'object' && item['attributes']['expires'] !== undefined) {
                let expires = new Date(item['attributes']['expires']);
                let expireTime = expires.getTime();
                let now = Date.now();
                if (expireTime > now) {
                    return item['data'];
                } else {
                    return null;
                }
            }
            return item && item['data'];
        }
    }

    getKey (key) {
        return this.prefix + ':' + key;
    }

    clear (key) {
        this.storage.removeItem(this.getKey(key));
    }
}


const storage = new Storage('local', env('NAME') + env('VERSION'));
const session = new Storage('session', env('NAME') + env('VERSION'));
export {storage, session};